
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import Dialog from 'primevue/dialog'
import descriptor from './OlapAlgorithmDialog.json'
import Dropdown from 'primevue/dropdown'
import InlineMessage from 'primevue/inlinemessage'

export default defineComponent({
    name: 'olap-algorithm',
    components: { Dialog, Dropdown, InlineMessage },
    props: { sbiExecutionId: { type: String } },
    emits: ['close'],
    data() {
        return {
            descriptor,
            selectedAlgorithm: {} as any,
            availableAlgorithms: [] as any
        }
    },
    created() {
        this.getAvailableAlgorithms()
    },
    methods: {
        async getAvailableAlgorithms() {
            await this.$http
                .get(process.env.VUE_APP_OLAP_PATH + `1.0/allocationalgorithm/?SBI_EXECUTION_ID=${this.sbiExecutionId}`, { headers: { Accept: 'application/json, text/plain, */*' } })
                .then((response: AxiosResponse<any>) => {
                    this.availableAlgorithms = response.data
                })
                .catch(() => {})
        },
        async changeAlgorithm() {
            await this.$http
                .post(process.env.VUE_APP_OLAP_PATH + `1.0/allocationalgorithm/${this.selectedAlgorithm.className}/?SBI_EXECUTION_ID=${this.sbiExecutionId}`, null, { headers: { Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json;charset=UTF-8' } })
                .then(async () => {
                    this.$store.commit('setInfo', { title: this.$t('common.toast.updateTitle'), msg: this.$t('common.toast.updateSuccess') })
                })
                .catch(() => {})
        }
    }
})
